import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

export const ButtonStyled = styled(Button)({
  height: '34px',
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  padding: '6px 12px',
  border: '1px solid',
  lineHeight: 1.5,
  background:  '#D41F44 0% 0% no-repeat padding-box;',
  borderColor: '#D41F44',
  font: 'normal normal normal 16px/18px Franklin Gothic Medium',
  '&:hover': {
    background:  '#D41F44 0% 0% no-repeat padding-box;',
    borderColor: '#D41F44',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    background:  '#D41F44 0% 0% no-repeat padding-box;',
    borderColor: '#D41F44',
  },
  // '&:focus': {
  //   boxShadow: '0 0 0 0.2rem rgba(212, 31, 68, 1)',
  // },
});

export const TextButtonStyled = styled(Button)({
  
  textTransform: 'none',
  color: '#D41F44',
  font: 'normal normal normal 14px/17px Franklin Gothic Medium',
});